export default {
	articles: "Articles",
	offerRequests: "Offres",
	offerRequestsHintTitle: "Nouveau : offres pour grandes quantités et séries",
	offerRequestsHintText:
		"Vous pouvez désormais demander ici des offres pour de grandes quantités, des pièces de série ou une fabrication robotisée automatisée.",
	orders: "Historique des commandes",
	cart: "Panier",
	account: "Compte",
	settings: "Paramètres",
	manageUsers: "Gérer les utilisateurs",
	logout: "Se déconnecter",
	hide: "Masquer",
	privateAccount: "Compte privé (numéro de client : {customerId})",
	companyAccount: "{companyName} (numéro de client : {customerId})",
	footer: {
		materials: "Matériaux",
		materialsTooltip: "Liste des matériaux disponibles",
		privacy: "Confidentialité",
		privacyTooltip: "Politique de confidentialité",
		terms: "CGV",
		termsTooltip: "Conditions générales de vente de Blexon",
		imprint: "Mentions légales",
		imprintTooltip: "Mentions légales",
		languageTooltip: "Modifier votre langue dans les paramètres du compte",
	},
};
